import { Box, debounce, Typography } from '@mui/material';
import { SmartFilter } from '../../components/common/SmartFilter';
import { useEffect, useState } from 'react';
import Pagination from '../../components/atoms/Pagination';
import { IGST } from '../../utils/entities/interface';
import { CreateTax, GetTaxation } from '../../services/taxation';
import { headerTaxTable } from '../../utils/constants';
import { Taxaxtion } from '../../components/ui/list/Taxation';
import CreateTaxation from './CreateTaxaxtion';
import useSnackbar from '../../hooks/useSnackbar';

interface FormData {
  name: string;
  gst: string;
  effectiveFrom: string;
}

const TaxationList = () => {
  const { SnackbarComponent, showSnackbar } = useSnackbar();
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [taxList, setTaxList] = useState<IGST[]>([]);
  const [totalTaxation, setTotalTaxation] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [taxModal, setTaxModal] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    name: '',
    gst: '',
    effectiveFrom: '',
  });

  useEffect(() => {
    fetchTaxation(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery]);

  // Fetch users from API
  const fetchTaxation = async (
    page: number,
    limit: number,
    searchQuery?: string,
    sort?: 'ASC' | 'DESC',
  ) => {
    try {
      setIsLoading(true);
      const response = await GetTaxation({
        page,
        limit,
        searchQuery,
        sortOrder: sort,
      });
      setTaxList(response.data);
      setTotalTaxation(response.pagination.totalRecords);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Debounced search handler
  const handleSearchRefresh = debounce((search: string) => {
    setSearchQuery(search);
    setPage(1);
  }, 500);

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  async function handleSubmit() {
    await CreateTax({
      name: formData.name,
      effectiveFrom: formData.effectiveFrom,
      gst: formData.gst,
    }).then((response) => {
      if (response.status == 201) {
        showSnackbar('Tool created successfully', 'success');
        setTaxModal(false);
        fetchTaxation(1, 10, '');
        setFormData({
          name: '',
          gst: '',
          effectiveFrom: '',
        });
      }
    });
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      {SnackbarComponent}
      <CreateTaxation
        open={taxModal}
        onClose={() => {
          setTaxModal(false);
          setFormData({
            name: '',
            gst: '',
            effectiveFrom: '',
          });
        }}
        onSaved={() => {
          handleSubmit();
        }}
        setFormData={setFormData}
        formData={formData}
      />
      <SmartFilter
        title="Taxation"
        createFilter={['SEARCH', 'ADD']}
        filterHeader={'Filter Taxation'}
        onNavigate={() => {
          setTaxModal(true);
        }}
        addDrawerSize="lg"
        onSearch={handleSearchRefresh}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          p: 1,
        }}
      >
        <Box
          sx={{
            height: '100%',
            maxHeight: '100%',
            overflowY: 'scroll',
            scrollbarWidth: 'none',
          }}
        >
          {taxList.length <= 0 && !isLoading ? (
            <Typography textAlign={'center'} marginTop={'20%'}>
              No Material Found
            </Typography>
          ) : (
            <Taxaxtion
              headerCells={headerTaxTable}
              taxList={taxList}
              isLoading={isLoading}
            />
          )}
        </Box>
        <Box display={'block'} bottom={0} right={0}>
          <Pagination
            count={totalTaxation}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TaxationList;
